module.exports = __webpack_public_path__ + "static/media/BIN_MASTER_v1.eaee7dc4.xlsx";